import { createContext } from "react";
import { type SyncManager } from "./manager";

export const Context = createContext<SyncManager | undefined>(undefined);
